import { render } from "./InterfaceButton.vue?vue&type=template&id=f4929260&scoped=true"
import script from "./InterfaceButton.vue?vue&type=script&lang=js"
export * from "./InterfaceButton.vue?vue&type=script&lang=js"

import "./InterfaceButton.vue?vue&type=style&index=0&id=f4929260&scoped=true&lang=scss"

import exportComponent from "/tmp/ee6909f6-e1a9-41e2-8541-cccc71f1c53b/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4929260"]])

export default __exports__